import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import WMSnackbar from '@workmarket/front-end-components/dist/WMSnackbar';
import WMLinearProgress from '@workmarket/front-end-components/dist/WMLinearProgress';
import $ from 'jquery';
import _ from 'underscore';

const WMUploader = ({ status: initialStatus, message }) => {
	const [status, setStatus] = useState(initialStatus);

	useEffect(() => {
		let timeoutId = null;

		const checkStatus = () => {
			$.getJSON('/uploadProgress/progress', (res) => {
				if (res && res.data && !_.isUndefined(res.data.uploadProgress)) {
					timeoutId = setTimeout(() => {
						setStatus(res.data.uploadProgress);
					}, 2000);

					if (res.data.uploadProgress === 1) {
						setTimeout(() => setStatus(0), 12000);
					}
				} else {
					timeoutId = setTimeout(checkStatus, 5000);
				}
			});
		};

		checkStatus();

		return () => {
			if (timeoutId) clearTimeout(timeoutId);
		};
	}, []);

	if (status > 0 && status < 1) {
		return (
			<WMSnackbar
				style={{ zIndex: '1200' }}
				bodyStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.74)' }}
				open={!!status}
				message={
					status === 1 ? (
						<div>
							<span>{message.done.title}</span>
							<span style={{ paddingLeft: '20px' }}>
								<a href={message.done.link.href}>{message.done.link.text}</a>
							</span>
						</div>
					) : (
						<div>
							<span>{message.start.title}</span>
							<WMLinearProgress
								style={{
									position: 'absolute',
									top: '24px',
									width: '150px',
									margin: '0 0 0 96px',
								}}
								color="#F79626"
								mode="indeterminate"
							/>
						</div>
					)
				}
			/>
		);
	}

	return null;
};

WMUploader.propTypes = {
	status: PropTypes.number.isRequired,
	message: PropTypes.shape({
		start: PropTypes.shape({
			title: PropTypes.string,
		}),
		done: PropTypes.shape({
			title: PropTypes.string,
			link: PropTypes.shape({
				href: PropTypes.string,
				text: PropTypes.string,
			}),
		}),
	}).isRequired,
};

export default WMUploader;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/WaypointShellNav/WMUploader.js